import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";
import { FingerprintContextType } from "./fingerprint-context.types";


const fingerprintData = sessionStorage.getItem("fp-pepper");

const initialState: FingerprintContextType = {
  fingerprint: JSON.parse(fingerprintData as string) || null,
  setFingerprint: () => { },
};

export const FingerprintContext = createContext(initialState);

export const FingerprintContextProvider: React.FC<PropsType> = ({ children }) => {
  const [fingerprint, setFingerprint] = useState<any>(
    initialState.fingerprint
  );

  useEffect(() => {
    if (fingerprint) {
      sessionStorage.setItem("fp-pepper", JSON.stringify(fingerprint));
    } else {
      sessionStorage.removeItem("fp-pepper");
    }
  }, [fingerprint]);

  return (
    <FingerprintContext.Provider value={{ fingerprint, setFingerprint }}>
      {children}
    </FingerprintContext.Provider>
  );
};
